import { useQuery } from "@apollo/react-hooks";
import { useMemo } from "react";
import { GET_USER_IDENTITY } from "../../graphql/queries/userIdentity";
import { Query } from "../../graphql/types";

const usePermissions = (): [Record<string, boolean>, boolean] => {
	const { data, loading } = useQuery<Required<Pick<Query, "user_identity">>>(GET_USER_IDENTITY);
	const userPermissions = useMemo<Record<string, boolean>>(() => {
		const user_permissions = data?.user_identity?.user_permissions || [];
		return user_permissions.reduce((acc, key) => {
			if (key) acc[key] = true;
			return acc;
		}, {});},[data]);
	return [userPermissions, loading];
};

 interface UserIdentity {
	username: string|null|undefined;
}
const useUserIdentities = (): UserIdentity => {
	const { data, loading } = useQuery<Required<Pick<Query, "user_identity">>>(GET_USER_IDENTITY);
	return useMemo<UserIdentity>(() => ({
		username: data?.user_identity?.username,
	}),[data]);
};


export { usePermissions, useUserIdentities };